import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Ciudad } from "@/shared/types/ciudad";

export interface CiudadAddRequest {
    nombre: string,
    codigo: string,
    departamentoId: string,
}

export async function addCiudad(request: CiudadAddRequest) : Promise<Ciudad> {
    await sleep(1000);
    const response = await api.post("ciudades", request);
    return response.data;
}

export function useAddCiudadMutation(mutationConfig: MutationConfig<Ciudad, CiudadAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addCiudad,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["ciudades"] });
        },
    })
}

export interface AddCiudadMutationProps {
    mutationConfig?: MutationConfig<Ciudad, CiudadAddRequest>
    children?: (mutationResult: MutationResult<Ciudad, CiudadAddRequest>) => ReactNode
}

export function AddCiudadMutation({
    mutationConfig,
    children
}: AddCiudadMutationProps) {
    const mutationResult = useAddCiudadMutation(mutationConfig);
    return children && children(mutationResult);
}
